import React, {useState,useEffect} from 'react';

import _ from 'lodash';
import cx from 'classnames';

import {
  Button,
  Form,
} from "react-bootstrap";

import styles from './resource.module.scss';


export function ResourceEditor({ value, type, onCancel, onSave}) {

  const [resources,setResources] = useState([
    {type:'LINK', url:''},
    {type:'SCRIPT', url:''}
  ])

  useEffect(()=>{
    if(value){
      setResources(value)
    }
  },[value])

  const handleAddResource = () => {
    setResources(state => [...state, {type:type,url:""}])
  }

const handleChangeResource = (resource, id)=>{
  let newResourceValues = ( resources || []).map((item,index) => {
    if(index === id) {
      return {
        ...item,
        url: resource
      }
    }
    else {
      return item;
    }
  });
  
  onSave(newResourceValues)
}

const handleRemoveResource = (deleteData) => {
  let resourceData = [];
  resourceData = [...resources]
  resourceData.splice(resourceData.findIndex(res => res.url === deleteData.url && res.type === deleteData.type),1);
  onSave(resourceData)

}

  return (
    <div className={styles.htmlSettingResource}>
      <div className={styles.resourceFields}>
        {
          resources.map((data, id) => {
            return (
              <div className={cx(styles.inputFieldWrapper,{[styles.hideFields]:data.type !== type})}>
                <Form.Control key={id} className={styles.resource} name={type} onChange={(e) => handleChangeResource(e.target.value, id,type)} type='text' value={data.url} />
                <button key={`${id}-${type}`} onClick={() => handleRemoveResource(resources[id])} className={styles.deleteResource} ><i className={'cleverstory-close'} /></button>
              </div>
            )
          })
        }
      </div>
      <Button className={styles.addButton} onClick={() => handleAddResource()} variant="light"><i className={'cleverstory-plus'} /> Add resource</Button>
      <Button onClick={()=>onCancel()} className={styles.closeButton} variant='secondary'>Close</Button>
    </div>
  )
}